"use client";

/**
 * Host shell for the Freshservice side-panel surface. Magnus runs inside a
 * cross-site iframe served by a Freshservice FDK app. Unlike the Office
 * add-ins there is no Office.js or MSAL; unlike Procore there is no postMessage
 * context handshake (ticket context arrives as URL params on the bootstrap page
 * and is persisted to sessionStorage there).
 *
 * Authentication follows the Procore pattern: the cross-site iframe can't
 * carry the SameSite=Lax Better-Auth cookie, so `FreshserviceAuthGate`
 * establishes a panel-scoped bearer + partitioned `SameSite=None` cookie via
 * a first-party popup (`/freshservice/auth/start`).
 */
import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { FreshserviceAuthGate } from "./freshservice-auth-gate";
export function FreshserviceShell(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <FreshserviceAuthGate>{children}</FreshserviceAuthGate>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}